import { render, staticRenderFns } from "./OpenNote.vue?vue&type=template&id=78420ad0&scoped=true&"
import script from "./OpenNote.vue?vue&type=script&lang=js&"
export * from "./OpenNote.vue?vue&type=script&lang=js&"
import style0 from "./OpenNote.vue?vue&type=style&index=0&id=78420ad0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78420ad0",
  null
  
)

export default component.exports